import { Line } from "@nivo/line";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useAutarkyLineWidth } from "src/components/monitoring/senec-stacked-bar-chart/autarky/useAutarkyLineWidth";
import { StackedBarData } from "src/components/monitoring/senec-stacked-bar-chart/SenecStackedBarChart";
import { ChartItemData, LineChartItem } from "src/components/monitoring/senec-line-chart/lineChartTypes";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";
import { CustomLineLayer } from "src/components/monitoring/ChartLines";

export const AutarkyLine = ({
    autarkyData,
    stackedBarGroupWidth,
    stackedBarStackWidth,
    stackedBarData,
}: {
    autarkyData: LineChartItem;
    stackedBarGroupWidth: number;
    stackedBarStackWidth: number;
    stackedBarData: StackedBarData[];
}) => {
    const theme: SenecBaseTheme = useTheme();
    const upTabletView = useMediaQuery(theme.breakpoints.up("tablet"));
    const fullAutarkyData = fillAutarkyData(stackedBarData, autarkyData);
    const width = useAutarkyLineWidth(
        fullAutarkyData?.data.length ?? 0,
        stackedBarGroupWidth,
        stackedBarStackWidth,
        upTabletView,
    );

    return (
        <Box
            style={{
                position: "absolute",
                height: "346px",
                left: "16px",
                right: "16px",
                display: "flex",
                justifyContent: "center",
                zIndex: 10,
            }}
            mx={"auto"}
        >
            <Line
                role={"monitor-charts-autarky"}
                data={fullAutarkyData ? [fullAutarkyData] : []}
                height={346}
                width={width}
                margin={{ top: 9, right: 0, bottom: 1, left: 0 }}
                xScale={{ type: "point" }}
                yScale={{
                    type: "linear",
                    min: 0,
                    max: 100,
                    reverse: false,
                }}
                isInteractive={false}
                pointSize={0}
                colors={theme.palette.senecSecondary.limeGreen}
                enableArea={true}
                areaBaselineValue={0}
                layers={[CustomLineLayer(autarkyData.id, true)]}
            />
        </Box>
    );
};

export const fillAutarkyData = (stackedBarData: StackedBarData[], autarkyData?: LineChartItem): LineChartItem | undefined => {
    if (autarkyData === undefined) return autarkyData;

    const autarkyDataArray = [...autarkyData.data];

    const fullAutarkyData: ChartItemData[] = [];
    stackedBarData.forEach((group, index) => {
        if (group.stackedBarItems === undefined || group.stackedBarItems.length === 0) {
            fullAutarkyData.push({ x: index, y: -1 }); // set empty value pairs to -1, so it is not shown in chart
        } else {
            const shift = autarkyDataArray.shift();
            if (shift != undefined) fullAutarkyData.push(shift);
        }
    });

    return { ...autarkyData, data: fullAutarkyData };
};
